export function shouldShowCookiePreferencesButton(routeName: string | symbol | null | undefined): boolean {
  return routeName === 'Login'
}

export function syncCookiePreferencesButtonVisibility(
  routeName: string | symbol | null | undefined
): void {
  const button = document.getElementById('btnOneTrust')

  if (!button) {
    return
  }

  const isVisible = shouldShowCookiePreferencesButton(routeName)

  if (isVisible) {
    button.style.removeProperty('display')
    button.setAttribute('aria-hidden', 'false')
    button.tabIndex = 0
    return
  }

  button.style.display = 'none'
  button.setAttribute('aria-hidden', 'true')
  button.tabIndex = -1
}
